import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';

@Component({
  selector: 'app-payment-add',
  templateUrl: './payment-add.component.html',
  styleUrls: ['./payment-add.component.scss']
})
export class PaymentAddComponent implements OnInit {
  data: any = {};
  drList: any = [];
  errorMsg: boolean = false;
  image_id: any;
  selected_image: any = [];
  lr_image: any = [];
  image = new FormData();
  url: any;
  savingFlag: boolean = false;
pageType :any = 'Add';


  constructor(public serve: DatabaseService, public toast: ToastrManager, public rout: Router) {
    this.url = this.serve.uploadUrl + 'checkin/';
    console.log(this.url, 'url');



  }

  ngOnInit() {
  }

  back() {
    window.history.go(-1);
  }

  distributors(data, search: any = '') {
    if (search != '') {
      search = search.target.value
    }
    this.serve.post_rqst({ 'dr_type': data, 'master_search': search }, 'Order/followupCustomer').subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.drList = result['result'];
      } else {
        this.toast.errorToastr(result['statusMsg'])
      }
    });
  }

  gettypeName(fulldata) {
    console.log(fulldata);
    this.data.dr_detail = fulldata
    // this.data.type_name2=this.data.type_name22
    // this.Dist_state = fulldata.state

  }

  deleteProductImage(index) {
    this.selected_image.splice(index, 1);
  }

  deleteLrImage(index) {
    this.lr_image.splice(index, 1);
  }

  onUploadChange(data: any) {
    this.errorMsg = false;
    this.image_id = '';
    for (let i = 0; i < data.target.files.length; i++) {
      let files = data.target.files[i];
      if (files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.selected_image.push({ "image": e.target.result });
        }
        reader.readAsDataURL(files);
      }
      this.image.append("" + i, data.target.files[i], data.target.files[i].name);
    }
    console.log(this.selected_image);
    console.log(this.image);

  }


   onLRUploadChange(data: any) {
    this.errorMsg = false;
    this.image_id = '';
    for (let i = 0; i < data.target.files.length; i++) {
      let files = data.target.files[i];
      if (files) {
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.lr_image.push({ "image": e.target.result });
        }
        reader.readAsDataURL(files);
      }
      this.image.append("" + i, data.target.files[i], data.target.files[i].name);
    }
    console.log(this.lr_image);
    console.log(this.image);

  }


  submitDetail() {
    // this.data.image = this.selected_image ? this.selected_image : [];
    this.data.image = this.selected_image.map(img => img.image);
    this.data.lr_image = this.lr_image.map(img => img.image); 

    this.savingFlag = true;



    this.serve.post_rqst({ 'data': this.data }, "Account/saveTransaction").subscribe(resp => {
      this.savingFlag = true;

      if (resp['statusCode'] == 200) {
        var toastString = ''
        this.toast.successToastr(resp['statusMsg'])
        this.savingFlag = false;



        this.rout.navigate(['/payment-listing']);

      } else {
        this.toast.errorToastr(resp['statusMsg']);
        this.savingFlag = false;

      }
    },
      error => {
        this.savingFlag = false;

      })




  }

}
